module.exports = __webpack_public_path__ + "static/media/claimBlue.0b616223.svg";